import styled from 'styled-components';

export const LinkActionBox = styled.button`
    margin: 0 auto;

    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    padding: 5px 0px 0px;
    border: 0;
    border-radius: 0;
    line-height: 1;
    ${({theme}) => theme.font.presets.body};
    font-size: 1.6rem;
    font-weight: 700;
    color: ${({theme}) => theme.colors.brandPrimary};
    text-decoration: underline;
    cursor: pointer;
`;
